import { IWizardStep } from "../../../../wizard/types";
import validator from "../validator";
import ManageContent from "../ManageContent";

export const createContentConfig: IWizardStep = {
  width: "552px",
  titleConfig: {
    titleText: "Add academic",
    // info: 'Choose whether you wanto study online or be at the campus. Choose whether you wanto study online or be at the campus.'
  },
  errorParser: (errors) => ({ ...errors }),
  content: ManageContent,
  validator: validator,
};
